const NUMBER_OF_ARTICLES = 4;
const FIREBASE_PROJECT_ID = 'nca-dna-preference-center';

// Hit production tcog for all environment, otherwise you wouldn't get anything.
const mapUrl = {
  'dev': 'a.tcog',
  'sit': 'a.tcog',
  'uat': 'a.tcog',
  'prod': 'a.tcog'
}

export const PRODUCT_MAP = {
  'dailytelegraph': {
    state: 'NSW',
    stateFull: 'New South Wales',
    targetDomain: 'dailytelegraph.com.au'
  },
  'heraldsun': {
    state: 'VIC',
    stateFull: 'Victoria',
    targetDomain: 'heraldsun.com.au'
  },
  'adelaidenow': {
    state: 'SA',
    stateFull: 'South Australia',
    targetDomain: 'adelaidenow.com.au'
  },
  'couriermail': {
    state: 'QLD',
    stateFull: 'Queensland',
    targetDomain: 'couriermail.com.au'
  },
  'ntnews': {
    state: 'NT',
    stateFull: 'Northern Territory',
    targetDomain: 'ntnews.com.au'
  }
}

export function getArticlesByMasthead(targetDomain, categoryId, displaySlug, product, environment) {
  const envSite = mapUrl[environment] || 'a.tcog';
  const categorySlug = categoryId ? `-${categoryId}` : ``;
  const targetDisplaySlug = `${displaySlug}${categorySlug}`;

  return `//${envSite}.news.com.au/news/v3/search?type=article&targetDomain=${targetDomain}&targetDisplaySlug=${targetDisplaySlug}&t_product=${product}&t_output=json&size=${NUMBER_OF_ARTICLES}`;
}

export function getCloudFunctionUrl(environment) {
  const envSite = environment === 'sit' ? 'sit' : 'prod';

  return `//us-central1-${FIREBASE_PROJECT_ID}.cloudfunctions.net/${envSite}/generateAuthToken`;
}

export function getArticlesBySuburb(domain, suburb, product, environment) {
  const envSite = mapUrl[environment] || 'a.tcog';
  const suburbUrl = encodeURI(suburb);
  const stateUrl = encodeURI(PRODUCT_MAP[product.toLowerCase()].stateFull);

  return `//${envSite}.news.com.au/news/v3/search?type=article&targetDomain=${domain}&categoriesLocationState=${stateUrl}&categoriesLocationSuburb=${suburbUrl}&t_product=${product}&t_output=json&size=${NUMBER_OF_ARTICLES}`;
}